import React, { useState, useEffect, useRef } from "react";
import promoteartistimg1 from './../../../../images/promoteartistimg1.png'
import promoteartistimg2 from './../../../../images/promoteartistimg2.png'
import promoteartistimg4 from './../../../../images/promoteartistimg4.png'
import promoteartistimg5 from './../../../../images/promoteartistimg5.png'
import promoteartistimg7 from './../../../../images/promoteartistimg7.jpg'
import promoteartistimg8 from './../../../../images/promoteartistimg8.png'
import promoteartistimg9 from './../../../../images/promoteartistimg9.jpg'
import promoteartistimg10 from './../../../../images/promoteartistimg10.png'
import promoteartistimg11 from './../../../../images/promoteartistimg11.png'
import promoteartistimg12 from './../../../../images/promoteartistimg12.png'
import promoteartistimg13 from './../../../../images/promoteartistimg13.png'
import promoteartistimg14 from './../../../../images/promoteartistimg14.png'
import promoteartistprotag from './../../../../images/promoteartistprotag.png'
import jppromoteartistprotag from './../../../../images/jp-promoteartistprotag.png'
import albumexampleimage2 from './../../../../images/albumexampleimg2.png'

import roundbackbtn from './../../../../images/roundbackicon.png'
import getverifiedpopupimg from './../../../../images/getverifiedpopupimg.png'
import crossicon from './../../../../images/crossicon.png'
import purplebackicon from './../../../../images/purplebackicon.png'
import YoutubeMonetize from "../YoutubeMonetize/YoutubeMonetize";
import VerifiedArtist from "./VerifiedArtist";
import LyricVideo from "./LyricVideo";
import PromoteYourselfMenu from "./PromoteYourselfMenu";
import withScrollToTop from "../../../Hybrid/ScrollToTop";
import requestsubmittedicon from './../../../../images/requestsubmittedicon.png'
import './PromoteYourself.css'
import ReactModal from 'react-modal';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import lyricvidborder from './../../../../images/lyricvidborder.png'
import lyricvid1 from './../../../../images/lyricvid1.png'
import lyricvid2 from './../../../../images/lyricvid2.png'
import lyricvid3 from './../../../../images/lyricvid3.png'
import lyricvid4 from './../../../../images/lyricvid4.png'
import lyricvid5 from './../../../../images/lyricvid5.png'
import lyricvid6 from './../../../../images/lyricvid6.png'
import lyricplayvid from './../../../../images/lyricplayvid.png'
import lyricviddots from './../../../../images/lyricviddots.png'
import lyricvidprice1 from './../../../../images/lyricvidprice1.png'
import lyricvidprice2 from './../../../../images/lyricvidprice2.png'
import lyricvidprice3 from './../../../../images/lyricvidprice3.png'
import lyricvidprice4 from './../../../../images/lyricvidprice4.png'
import lyricvidcusprice1 from './../../../../images/lyricvidcusprice1.png'
import lyricvidcusprice2 from './../../../../images/lyricvidcusprice2.png'
import lyricvidcusprice3 from './../../../../images/lyricvidcusprice3.png'
import Select from 'react-select'
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import backbtn from './../../../../images/backicon.png'
import WorldCollection from "./WorldCollection";
import { useLocation, useNavigate } from "react-router-dom";
import { Route, Routes, Redirect, Navigate } from 'react-router-dom'
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";

function PromoteYourself({ hidedashboard, nav }) {

  const location = useLocation();
  const cookies = new Cookies(null, { path: '/' });
  const hasLogged = useRef(false);


  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  var myfun = function (ele) {
    let offsetTop = document.getElementById(ele).offsetTop;
    var right = document.getElementById("#PYContainer");
    window.scrollTo({
      top: offsetTop - 0,
      behavior: "smooth"
    });
  }

  useEffect(() => {
    // topFunction()
    nav("PromoteYourself")
    hidedashboard(true)

    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard Promote Yourself Page", { "desc": "User opened the artist dashboard promote yourself page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Artist Dashboard Promote Yourself Page", { "desc": "User opened the artist dashboard promote yourself page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Artist Dashboard Promote Yourself Page", { "desc": "User opened the artist dashboard promote yourself page" })
        hasLogged.current = true;
      }
    }
  }, [])

  useEffect(() => {
    // topFunction()
    // myfun("PYContainer")
    console.log("Fired")
    window.scrollTo(0, 0);
  }, [location.pathname])






  return (
    <div className="PYContainer">


      <Routes>
        <Route exact path="/" element={<PromoteYourselfMenu />} />
        <Route exact path="/verifiedartist" element={<VerifiedArtist />} />
        <Route exact path="/lyricvideo" element={<LyricVideo />} />
        <Route exact path="/youtubemonetize" element={<YoutubeMonetize />} />
        <Route exact path="/worldcollection" element={<WorldCollection />} />
      </Routes>

      {/* {
            isYMonetize &&
              <YoutubeMonetize nav={ToggleYTMonetize}/>
          } */}

      {/* {
            isWorldCollection &&
             <WorldCollection hidedashboard={hidedashboard} nav={ToggleWorlds}/>
          } */}

      {/* {
            isVArtist &&
           
              <VerifiedArtist/>
           
          } */}

      {/* {
            LyricVideo &&
            <LyricVideo/>
        } */}

    </div>

  );
}

export default PromoteYourself;